// src/app/shared/components/update-banner/update-banner.component.ts
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AppUpdateService } from '../../../core/services/conf/app-update.service';

/**
 * Banner de actualización estilo Netlify.
 * Se muestra en la parte superior de la pantalla cuando `updateAvailable$` emite `true`.
 * Incluir en: AppComponent y LoginComponent.
 *
 * Uso:
 *   <app-update-banner />
 */
@Component({
    selector: 'app-update-banner',
    standalone: true,
    imports: [CommonModule, ButtonModule],
    templateUrl: './update-banner.component.html',
    styleUrl: './update-banner.component.scss'
})
export class UpdateBannerComponent {
    readonly updateService = inject(AppUpdateService);
}
